export const defaultHeaders = {
    'Content-Type': 'application/json',
}
